import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal } from '@plone/volto/components';
import NewsBlockData from './Data';
import NewsBlockView from './View';

const NewsBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <NewsBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <NewsBlockData data={data} block={block} onChangeBlock={onChangeBlock} />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(NewsBlockEdit);
